// Hiragana (U+3041 - U+3096) -> Shift-JIS (0x829F - 0x82F1)
export const HIRAGANA_START = 0x3041;
